var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskProcessSeasonalTask = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.688 3.23a2.154 2.154 0 0 1 2.224 1.888c.914 7.39-5.216 13.737-12.626 13.092l-.635 2.545a.623.623 0 0 1-1.208-.301l.878-3.51a12.45 12.45 0 0 1 4.434-6.81l2.381-1.85a.622.622 0 1 1 .764.983l-2.38 1.852a11.2 11.2 0 0 0-3.92 5.863c6.529.443 11.884-5.175 11.076-11.711a.91.91 0 0 0-.938-.798l-4.065.163c-4.773.191-8.35 4.35-7.922 9.022a.66.66 0 0 1-.535.72.593.593 0 0 1-.696-.514C3.97 8.45 8.1 3.612 13.623 3.39z"
})));
export default SvgTaskProcessSeasonalTask;